import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/initial-screen-ensimimav.jpg'


const _withScopeId = n => (_pushScopeId("data-v-0684bf8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1123px","width":"801px","max-height":"1236px","max-width":"801px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Deckblatt mit Acon-Logo",
    style: {"height":"1123px","width":"801px","max-height":"1236px","max-width":"801px"}
  })
], -1))
const _hoisted_4 = { class: "landing_page" }
const _hoisted_5 = { class: "title-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-4xl",
  "data-cy": "pdf-coverpage-header"
}, " ACON 360° ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-5xl" }, " Heizungsprüfung und Heizungsoptimierung ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "mt-2 text-l flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, "Objekt:", -1))
const _hoisted_11 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-street"
}
const _hoisted_12 = { class: "text-l flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, null, -1))
const _hoisted_14 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-city"
}
const _hoisted_15 = { class: "text-l flex mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, "Berichtnummer:", -1))
const _hoisted_17 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-begehungsdatum"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "acon-energie.de",
  class: "acon-link"
}, "acon-energie.de", -1))
const _hoisted_19 = {
  class: "mt-2 mb-0 text-base font-bold",
  "data-cy": "genericContent-header"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  class: "pdf-title",
  "data-cy": "pdf-overviewpage-mainheader"
}
const _hoisted_22 = {
  class: "pdf-subtitle",
  "data-cy": "pdf-overviewpage-overviewheader"
}
const _hoisted_23 = {
  class: "pdf-subtitle",
  "data-cy": "pdf-overviewpage-overviewheader"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-xs text-justify",
  style: {"margin":"0px 0px 20px 0px","padding-top":"15px"}
}, " Wir bitten gem. der Optimierungsempfehlungen um Angebotserstellung für (bitte entsprechend ankreuzen): ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empfehlung-entry" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "empfehlung1",
    type: "checkbox",
    name: "empfehlung1",
    class: "checkbox"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-xs text-justify",
    style: {"margin":"0px 0px 0px 10px"}
  }, "1. die Einstellung der technischen Parameter (Eine funktionsfähige Regelgruppe ist hierbei vorausgesetzt.)")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empfehlung-entry" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "empfehlung2",
    type: "checkbox",
    name: "empfehlung2",
    class: "checkbox"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: /*#__PURE__*/_normalizeClass(['text-xs', 'text-justify']),
    style: {'margin': '0px 0px 0px 10px'}
  }, "2. die Durchführung eines hydraulischen Abgleichs nach Verfahren B")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empfehlung-entry" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "empfehlung3",
    type: "checkbox",
    name: "empfehlung3",
    class: "checkbox"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-xs text-justify",
    style: {"margin":"0px 0px 0px 10px"}
  }, "3. die Erneuerung der nicht effizienten Heizungspumpe")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empfehlung-entry" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "empfehlung4",
    type: "checkbox",
    name: "empfehlung4",
    class: "checkbox"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-xs text-justify",
    style: {"margin":"0px 0px 0px 10px"}
  }, "4. die Durchführung von Dämmmaßnahmen an Rohrleitungen und/oder Armaturen")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empfehlung-entry" }, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "empfehlung5",
    type: "checkbox",
    name: "empfehlung5",
    class: "checkbox"
  }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-xs text-justify",
    style: {"margin":"0px 0px 0px 10px"}
  }, "5. die Behebung der festgestellten Mängel")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mt-8 mb-0 text-base",
  "data-cy": "hinweis-title"
}, " Hinweis ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-col",
  "data-cy": "hinweis-text"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2 ml-0 text-xs text-justify" }, " Die Anpassung der Regeleinstellungen im Zuge der Optimierungsmaßnahmen kann Auswirkungen auf die von den Nutzern gewohnte Wärmebereitstellung haben. Die Kosten für jede weitere Abänderung der Regeleinstellungen werden gemäß der zu dem Zeitpunkt gültigen Preisliste berechnet. ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-8",
  "data-cy": "ansprechpartner",
  style: {"margin-top":"30rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex mt-4" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "flex flex-col w-1/2",
      "data-cy": "signatur-1"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "border-top-dotted-1 ml-4" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "text-xxs mt-2" }, [
          /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Ort und Datum")),
          /*#__PURE__*/_createElementVNode("br")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "flex flex-col w-1/2",
      "data-cy": "signatur-2"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "border-top-dotted-1 ml-4" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "text-xxs mt-2" }, [
          /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Unterschrift und Stempel des Hauseigentümers / der Hausverwaltung") + ":"),
          /*#__PURE__*/_createElementVNode("br")
        ])
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageCounterStart = _resolveComponent("PageCounterStart")!
  const _component_PageCounter = _resolveComponent("PageCounter")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_PdfEnsimimavOverviewPage = _resolveComponent("PdfEnsimimavOverviewPage")!
  const _component_Heizkreise = _resolveComponent("Heizkreise")!
  const _component_Waermeverteilung = _resolveComponent("Waermeverteilung")!
  const _component_pdf_page_header = _resolveComponent("pdf-page-header")!
  const _component_PdfMSEDataTable = _resolveComponent("PdfMSEDataTable")!
  const _component_pdf_data_section_summary = _resolveComponent("pdf-data-section-summary")!
  const _component_pdf_color_codes = _resolveComponent("pdf-color-codes")!
  const _component_pdf_mangel_input_page_ensimimav = _resolveComponent("pdf-mangel-input-page-ensimimav")!
  const _component_PageCounterEnd = _resolveComponent("PageCounterEnd")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.detailPages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_PageCounterStart),
          _createVNode(_component_PageCounter, {
            "display-counter": false,
            "display-max-pages": false
          }),
          _createVNode(_component_pdf_a4_page, {
            class: "logo_page",
            "no-margin": "",
            "pdf-key": _ctx.lang
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.immobilie.strasse), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.immobilie.plz) + " " + _toDisplayString(_ctx.immobilie.stadt) + " " + _toDisplayString(_ctx.immobilie.stadtbezirk), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.moment(_ctx.ba.begehungsdatum).format("MM-YYYY")), 1),
                    _hoisted_18
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["pdf-key"]),
          _createVNode(_component_PdfEnsimimavOverviewPage, {
            lang: _ctx.lang,
            ba: _ctx.ba,
            immobilie: _ctx.immobilie
          }, null, 8, ["lang", "ba", "immobilie"]),
          _createVNode(_component_Heizkreise, {
            lang: _ctx.lang,
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            "table-of-content-m-s-e-data": _ctx.tableOfContentMSEData
          }, null, 8, ["lang", "ba", "immobilie", "table-of-content-m-s-e-data"]),
          _createVNode(_component_Waermeverteilung, {
            lang: _ctx.lang,
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            "table-of-content-m-s-e-data": _ctx.tableOfContentMSEData
          }, null, 8, ["lang", "ba", "immobilie", "table-of-content-m-s-e-data"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailPages, (detailPage, key) => {
            return (_openBlock(), _createBlock(_component_pdf_a4_page, {
              key: key,
              "pdf-key": _ctx.lang,
              "data-cy": "generic-content-page"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_pdf_page_header, {
                  immobilie: _ctx.immobilie,
                  hzba: _ctx.ba,
                  "tech-data": _ctx.tableOfContentFragenblocks,
                  active: detailPage.fragenblock?.getTitle(),
                  lang: _ctx.lang
                }, null, 8, ["immobilie", "hzba", "tech-data", "active", "lang"]),
                _createElementVNode("h2", _hoisted_19, _toDisplayString(detailPage.fragenblock.getTitle(_ctx.lang) +
              (detailPage.titleSuffix || "")), 1),
                (detailPage.fragenblockMSERows)
                  ? (_openBlock(), _createBlock(_component_PdfMSEDataTable, {
                      key: 0,
                      data: detailPage.fragenblockMSERows,
                      "show-title": true,
                      "value-title": null,
                      lang: _ctx.lang
                    }, null, 8, ["data", "lang"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_pdf_data_section_summary, {
                  title: detailPage.fragenblock?.getTitle(_ctx.lang),
                  data: detailPage.fragenblock?.maengelReport()?.getMSESummary()
                }, null, 8, ["title", "data"]),
                _createVNode(_component_pdf_color_codes, {
                  class: "ml-1",
                  lang: _ctx.lang
                }, null, 8, ["lang"])
              ]),
              _: 2
            }, 1032, ["pdf-key"]))
          }), 128)),
          _createVNode(_component_pdf_mangel_input_page_ensimimav, {
            immobilie: _ctx.immobilie,
            ba: _ctx.ba,
            "tech-data": _ctx.tableOfContentFragenblocks,
            lang: _ctx.lang,
            "custom-inputs": _ctx.mangelInputsEnsimimav,
            title: _ctx.t('hzba.pdf.ensimimav.mangelUebersichtEnsimimav', 1, { locale: _ctx.lang }),
            noValues: _ctx.t('hzba.pdf.ensimimav.keinOptimierungspotenzial', 1, { locale: _ctx.lang }),
            "crumbs-beginning": 'IST-Einstellparameter > IST-Dämmung > ',
            "crumbs-middle": 'Optimierungspotenzial',
            "crumbs-end": ' > Mängel'
          }, null, 8, ["immobilie", "ba", "tech-data", "lang", "custom-inputs", "title", "noValues"]),
          _createVNode(_component_pdf_mangel_input_page_ensimimav, {
            immobilie: _ctx.immobilie,
            ba: _ctx.ba,
            "tech-data": _ctx.tableOfContentFragenblocks,
            lang: _ctx.lang,
            "custom-inputs": _ctx.mangelInputs,
            title: _ctx.t('hzba.pdf.ensimimav.sonstigeMaengel', 1, { locale: _ctx.lang }),
            noValues: _ctx.t('hzba.pdf.ensimimav.keineMaengel', 1, { locale: _ctx.lang }),
            unterschrift: true,
            "crumbs-beginning": 'IST-Einstellparameter > IST-Dämmung > Optimierungspotenzial > ',
            "crumbs-middle": 'Mängel',
            "crumbs-end": ''
          }, null, 8, ["immobilie", "ba", "tech-data", "lang", "custom-inputs", "title", "noValues"]),
          _createVNode(_component_pdf_a4_page, { "pdf-key": _ctx.lang }, {
            default: _withCtx(() => [
              _createVNode(_component_pdf_page_header, {
                immobilie: _ctx.immobilie,
                hzba: _ctx.ba,
                "tech-data": [],
                lang: _ctx.lang,
                "show-chapters": false
              }, null, 8, ["immobilie", "hzba", "lang"]),
              _hoisted_20,
              _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.t("hzba.pdf.entscheidungPruefung", 1, { locale: _ctx.lang })), 1),
              _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.t("hzba.pdf.ensimimavParagraph", 1, { locale: _ctx.lang })), 1),
              _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.t("hzba.pdf.ensimimavSubtitle", 1, { locale: _ctx.lang })), 1),
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33
            ]),
            _: 1
          }, 8, ["pdf-key"]),
          _createVNode(_component_PageCounterEnd)
        ]))
      : _createCommentVNode("", true)
  ]))
}